module.exports = __webpack_public_path__ + "img/AO.296f77ba.svg";